import clsx from 'clsx'
import { type ForwardedRef, forwardRef } from 'react'
import type { NavLinkProps } from 'react-router'

import {
  FvLinkButton,
  type FvLinkButtonProps,
  FvNavLink,
  Icon,
  type IconName,
} from '@fv/client-components'

type Props = FvLinkButtonProps & {
  button?: boolean
}
export const AdminLink = forwardRef(
  (
    { className, button, ...props }: Props,
    ref: ForwardedRef<HTMLAnchorElement>,
  ) => (
    <FvLinkButton
      ref={ref}
      className={clsx(
        {
          'link text-primary': !button,
          btn: button,
        },
        className,
      )}
      iconClass={clsx('mr-2', props.iconClass)}
      {...props}
    >
      {props.children}
    </FvLinkButton>
  ),
)

type AdminNavLinkProps = NavLinkProps & { icon?: IconName }

export const AdminNavLink = ({
  className,
  children,
  ...props
}: AdminNavLinkProps) => {
  return (
    <FvNavLink
      className={state =>
        clsx(
          'link',
          typeof className === 'function' ? className(state) : className,
          {
            'text-primary': !(
              typeof className === 'function' ? className(state) : className
            )?.includes('text-'),
          },
        )
      }
      {...props}
    >
      {state => (
        <>
          {props.icon && <Icon className="mr-2" icon={props.icon} />}
          {typeof children === 'function' ? children(state) : children}
        </>
      )}
    </FvNavLink>
  )
}
